var IS_BOT_BY_CAMPAIGN_COOKIE_KEY = 'is_bot_by_campaign';
/**
 * Определяем это бот или нет
 */

export function getCanRunAds() {
  if (window._cianCanRunAds === false) {
    return false;
  } // Проверяем, что в куках нет флага, что пользователь бот


  var isBot = doesCookieExist(IS_BOT_BY_CAMPAIGN_COOKIE_KEY);

  if (!isBot) {
    var urlParams = new URLSearchParams(window.location.search);
    var utmCampaign = urlParams.get('utm_campaign'); // Проверяем, на признак бота по utm_campaign, боты яндекса ходят с utm_campaign, которые удовлетворяют условиям
    // 1. Длина не более 9 символов
    // 2. Состоят только из цифр

    if (!!utmCampaign && utmCampaign.length <= 9 && /^[0-9]+$/.test(utmCampaign)) {
      isBot = true;
    }
  }

  return !isBot;
}

function doesCookieExist(cookieName) {
  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();

    if (cookie.startsWith("".concat(cookieName, "="))) {
      return true;
    }
  }

  return false;
}